<!-- Schedule -->
<div *ngIf="!isLoading && schedule" id="scheduleContent" class="px-1 pb-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h6 class="mb-0 fw-semibold small">
      <i class="bi bi-people-fill me-1"></i>All Employees
    </h6>
    <button
      class="btn btn-outline-primary btn-sm py-0 px-2"
      style="font-size: 0.7rem"
      (click)="printSchedule()"
    >
      <i class="bi bi-printer me-1"></i>Print
    </button>
  </div>

  
  <div class="table-responsive" style="overflow-x: hidden">
    <table
      class="table table-bordered table-sm align-middle text-center mb-2"
      style="
        font-size: 0.58rem;
        line-height: 1.15;
        border-color: #ddd;
        table-layout: fixed;
      "
    >
      <thead class="table-light">
        <tr>
          <th
            class="text-start px-1 py-1"
            style="width: 18%; white-space: nowrap"
          >
            Name
          </th>
          <th
            *ngFor="let day of dayKeys; let i = index"
            class="px-0 py-1"
            style="width: 11%"
          >
            <div style="line-height: 1.1; white-space: nowrap;">
              {{ day }} {{ weekDates[i] ? (weekDates[i] | date : "M/d") : "TEST" }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let emp of schedule.result"
          [class.table-primary]="
            emp.name.toLowerCase() === employeeName?.toLowerCase()
          "
        >
          <td
            class="text-start px-1 py-1 fw-semibold text-truncate"
            style="max-width: 100px"
          >
            {{ emp.name }}
          </td>
          <td *ngFor="let day of dayKeys" class="px-0 py-1">
            <span
              [ngClass]="{
                'text-success': isWorkDayFor(emp, day),
                'text-secondary':
                  !isWorkDayFor(emp, day) && !isRequestedOffFor(emp, day),
                'text-danger': isRequestedOffFor(emp, day)
              }"
              style="
                display: block;
                white-space: normal;
                font-size: 0.56rem;
                line-height: 1.1;
              "
            >
              {{ getShift(emp, day) }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Legend -->
  <div
    class="d-flex justify-content-center gap-2 mt-1 flex-wrap text-muted no-print"
    style="font-size: 0.65rem"
  >
    <span class="text-success">● Working</span>
    <span class="text-secondary">● Off</span>
    <span class="text-danger">● Requested Off</span>
  </div>

  <!-- Info -->
  <div class="text-center mt-1">
    <small class="text-muted" style="font-size: 0.65rem">
      <i class="bi bi-info-circle me-1"></i>
      Published {{ schedule.publishedAt?.toDate() | date : "short" }}
    </small>
  </div>
</div>